<template>
	<header id="header">
		<div class="hInner header_notice subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link :to='`/board/${board_type}`'></router-link></div>
				<div class="hLine"></div>
				<div class="hName">공지사항</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>

	<section id="notice">
		<div class="content content_w notice">
			<div class="contIn">
				<div class="searchBox">
					<form ref="form_search" id="form_search" @submit.prevent="getModels()">
						<input type="hidden" v-model="searchModels.sca">
						<input type="hidden" v-model="searchModels.sop">

						<div class="searchRow">
							<div class="searchCont">
								<select v-model="searchModels.category" id="category">
									<option value="board_subject">제목</option>
									<option value="board_content">내용</option>
									<option value="board_subject||board_content">제목+내용</option>
									<option value="mb_name">글쓴이</option>
									<option value="mb_nick">소속</option>
								</select>
								<input id="notice_search_box" name="keyword" type="text" v-model="searchModels.keyword" placeholder="검색어 입력">
							</div>
							<div>
								<button type="button" class="search_btn" id="searchBtn" @click.prevent="getModels()">검색</button>
								<button type="button" v-show="isSearchActive" class="search_btn reset_btn" @click="searchReset()">초기화</button>
							</div>
						</div>
					</form>
				</div>

				<DataTable :headers="headers" :itemsData="items" :perPage="10" :showNum="true" showNew="board_subject" checkedField="items.idx"
					:dateFormat="'YYYY-MM-DD'" :dateTarget="'createdAt'" />

				<ul class="notice_BtnWrap subBtn">
					<li><button type="button" class="notice_addBtn" @click="goto_url(`/board_write/${board_type}`)">글쓰기</button></li>
				</ul>
			</div>
		</div>
	</section>

</template>

<script>
import header from '../components/layout/header.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import DataTable from '@/components/layout/DataTable';

const route = useRoute();
const router = useRouter();

const props = defineProps({
	type: {
		type: String,
		required: true
	},
});

const board_type = ref(props.type);

watch(
	() => props.type,
	(newVal) => {
		board_type.value = newVal;
	}
);

const goto_url = (url) => {
	router.push(url);
}

let form_search = ref(null)
let searchModels = ref({
	category: 'board_subject'
})

onMounted(async () => {
	await getModels();
});

// 초기화 함수
const searchReset = async () => {
	searchModels.value = Object.assign({});
	form_search.value.reset();
	document.querySelectorAll('form#form_search select').forEach(function (selectElement) {
		selectElement.value = 'board_subject';
		selectElement.selected = true;
	});
	searchModels.value.category = 'board_subject';

	await getModels();
}

// 하나라도 검색 조건이 지정되어 있는지 확인
const isSearchActive = computed(() => {
	return searchModels.value.keyword && searchModels.value.keyword !== '';
});

const headers = ref([]);
const items = ref([]);

headers.value = [
	{ label: '제목', key: 'board_subject' },
	{ label: '작성자', key: 'memberBoard.mb_name' },
	{ label: '소속', key: 'memberBoard.mb_nick' },
	{ label: '작성일', key: 'createdAt' }
];

// 예시 데이터 설정
// items.value = [
// { 'idx': '1', 'board_subject': '공지합니다.', 'memberBoard.mb_nick': '김닥터', 'memberBoard.mb_nick': 'xx치과', createdAt: '2024-05-29' }
// ];

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('board_type', board_type.value);
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('orderBy', 'id'); // 정렬필드
	params.append('align', 'desc'); // 정렬순서

	if (searchModels.value != undefined) {
		Object.keys(searchModels.value).map(v => {
			params.append(v, searchModels.value[v]);
		});
	}

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/board`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
	} catch (error) {
console.error('Error getModels:', error);
	}
}

window.getModels = getModels;
</script>